import { render, staticRenderFns } from "./SegmentEdit.vue?vue&type=template&id=5a73b4eb&scoped=true"
import script from "./SegmentEdit.vue?vue&type=script&lang=js"
export * from "./SegmentEdit.vue?vue&type=script&lang=js"
import style0 from "./SegmentEdit.vue?vue&type=style&index=0&id=5a73b4eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a73b4eb",
  null
  
)

export default component.exports